export default __webpack_public_path__ + "static/media/menu4.f3c8dff5.jpeg";